import React, { memo } from "react";

import { OTAOverviewCards } from "../OTAOverviewCards";

export const SetupView = memo(() => {
  return (
    <div>
      <OTAOverviewCards />
    </div>
  );
});
